import React from 'react';
import './css/OfferStyle.css';
import icon1 from './offer-logo/vigyanvriksh_barc.png';
import icon2 from './offer-logo/vigyanvriksh_csir.png';
import icon3 from './offer-logo/vigyanvriksh_iisc.png';
import icon4 from './offer-logo/vigyanvriksh_iiserbhopal.png';
import icon5 from './offer-logo/vigyanvriksh_iiserpune.png';
import icon6 from './offer-logo/vigyanvriksh_iitbombay.png';
import icon7 from './offer-logo/vigyanvriksh_iitdelhi.png';
import icon8 from './offer-logo/vigyanvriksh_iitguwahati.png';
import icon9 from './offer-logo/vigyanvriksh_iitkanpur.png';
import icon10 from './offer-logo/vigyanvriksh_iitkharagpur.png';
import icon11 from './offer-logo/vigyanvriksh_iitmadra.png';
import icon12 from './offer-logo/vigyanvriksh_iitroorkee.png';
import icon13 from './offer-logo/vigyanvriksh_jncsar.png';
import icon14 from './offer-logo/vigyanvriksh_nclpune.png';


function Offer() {
    return (
        <div className='offerbox'>
        <div class="container py-5 mt-5 mb-5 ">
            <div class="row align-items-center">
        
                <div class="col-lg-6 mb-5 mb-lg-0">
                    <h2 class="fw-bold">We Offer Top Trending<br />Program for <span class="highlight-text">Chemistry</span></h2>
                    <p class="text-muted my-3">Explore our top trending chemistry programs tailored to boost your knowledge and career success.</p>
                    <div class="language-icons d-flex flex-wrap mt-4">
                        <img src={icon1} alt="vigyanvriksh_barc" />
                        <img src={icon2} alt="vigyanvriksh_csir" />
                        <img src={icon3} alt="vigyanvriksh_iisc" />
                        <img src={icon4} alt="vigyanvriksh_iiserbhopal" />
                        <img src={icon5} alt="vigyanvriksh_iiserpune" />
                        <img src={icon6} alt="vigyanvriksh_iitbombay" />
                        <img src={icon7} alt="vigyanvriksh_iitdelhi" />
                        <img src={icon8} alt="vigyanvriksh_iitguwahati" />
                        <img src={icon9} alt="vigyanvriksh_iitkanpur" />
                        <img src={icon10} alt="vigyanvriksh_iitkharagpur" />
                        <img src={icon11} alt="vigyanvriksh_iitmadra" />
                        <img src={icon12} alt="vigyanvriksh_iitroorkee" />
                        <img src={icon13} alt="vigyanvriksh_jncsar" />
                        <img src={icon14} alt="vigyanvriksh_nclpune" />
                    </div>
                </div>

                <div class="col-lg-6">
                    <form class="subscription-form">
                        <div class="row mb-3">
                            <div class="col">
                                <input type="text" class="form-control" placeholder="First Name*" required />
                            </div>
                            <div class="col">
                                <input type="text" class="form-control" placeholder="Last Name*" required />
                            </div>
                        </div>
                        <div class="mb-3">
                            <input type="email" class="form-control" placeholder="Your Email*" required />
                        </div>
                        <div class="mb-3">
                            <input type="text" class="form-control" placeholder="Your Mobile Number*" required />
                        </div>
                        <div class="mb-3">
                            <select class="form-select">
                            <option selected disabled>Where would you like to learn?</option>
                            <option>Online</option>
                            <option>Offline</option>
                            <option>Hybrid</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label fw-semibold">What topics are you Interested In?</label>
                            <div class="d-flex flex-wrap">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="coding" />
                                    <label class="form-check-label" for="coding">CSIR NET</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="marketing" />
                                    <label class="form-check-label" for="marketing">IIT GATE</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="design" />
                                    <label class="form-check-label" for="design">IIT JAM</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="business" />
                                    <label class="form-check-label" for="business">Assistant Professor</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="business" />
                                    <label class="form-check-label" for="business">PGT Chemistry</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="business" />
                                    <label class="form-check-label" for="business">B. Sc. Chemistry</label>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-gradient form-control w-100 py-2 mb-2">Save & Subscribe</button>
                    </form>
                </div>
            </div>
        </div>
        </div>
    );
}
export default Offer;